import React from 'react';
import { cn } from '../utils/cn';

const Input = ({ label, value, inputCb, id, type = 'text', placeholder, className, classContainer, ...restProps }) => {
  return (
    <div className={cn(classContainer)}>
      <label className="block text-gray-700 text-sm ml-2 mb-2" htmlFor={id}>
        {label}
      </label>
      <input
        value={value}
        onChange={(e) => inputCb(e)}
        className={cn(`appearance-none border border-gray-300 pl-4 rounded-full w-full h-10 px-3 text-gray-700 leading-tight focus:outline-none`, className)}
        id={id}
        type={type}
        placeholder={placeholder}
        name={id}
        {...restProps}
      />
    </div>
  );
};

export default Input;
